import {
  Brain, Share2, ShieldCheck, BarChart3, Heart, TrendingUp,
  FileText, Settings, Workflow, Users, MonitorSmartphone,
  Activity, Briefcase, ArrowRight, ArrowLeft, Search, X, Mail, Phone,
  Linkedin, Youtube, Twitter, Instagram, Stethoscope, Cpu, Building2,
  HeartPulse, Cloud, Database, Home, GraduationCap, Video, Microscope,
  Bone, Wrench, Server, ScanLine, Lock, LineChart, CheckCircle2, Boxes,
  User, LogOut, Inbox, Sparkles, Flame, Star, MessageSquare, Send, Tag, Info,
} from "lucide-react";

const MAP = {
  Brain, Share2, ShieldCheck, BarChart3, Heart, TrendingUp,
  FileText, Settings, Workflow, Users, MonitorSmartphone,
  Activity, Briefcase, ArrowRight, ArrowLeft, Search, X, Mail, Phone,
  Linkedin, Youtube, Twitter, Instagram, Stethoscope, Cpu, Building2,
  HeartPulse, Cloud, Database, Home, GraduationCap, Video, Microscope,
  Bone, Wrench, Server, ScanLine, Lock, LineChart, CheckCircle2, Boxes,
  User, LogOut, Inbox, Sparkles, Flame, Star, MessageSquare, Send, Tag, Info,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Heart;
  return <Cmp {...props} />;
}
